<mat-sidenav-container>
  <mat-sidenav
    class="main row create_campaign"
    #sidenav
    mode="over"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="60"
    [opened]="campaignState.openCreateCampaignSheet$ | async"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>Campaign Details</h4>
      <button type="button" (click)="closeSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="slidesheetcontent">
      <form [formGroup]="campaignForm">
        <div class="row mx-1 mb-1" *ngIf="campaignMode != 'isAutomatedCampaign'">
          <div class="col-md-12">
            <!-- <div class="d-flex align-items-center flex-nowrap step-header mb-2">
              <span class="step-circle">1</span>
              <h5 class="mb-0 step-title">Start By Entering Basic Campaign Information</h5>
            </div> -->
            <div class="campaign-step mb-3">
              <div class="step-circle">
                <span>1</span>
              </div>

              <div class="step-content">
                <h5 class="step-title mb-0">Start By Entering Basic Campaign Information</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-1 mb-1" *ngIf="campaignMode != 'isAutomatedCampaign'">
          <div class="col-md-3 col-12">
            <mat-form-field class="w-100">
              <mat-label> Campaign Name </mat-label>
              <input matInput autocomplete="off" placeholder="Campaign Name" formControlName="campaignName" />
              <mat-error
                *ngIf="campaignFormCtrlList.campaignName.errors && campaignFormCtrlList.campaignName.errors.required"
                class="invalid-feedback"
                >Campaign name is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-12">
            <mat-form-field class="w-100">
              <mat-label>Campaign Types</mat-label>
              <mat-select formControlName="campaignType">
                <ng-container *ngFor="let type of campaignList">
                  <mat-option [value]="type.value">{{ type.displayText }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            class="col-md-3 col-12"
            *ngIf="authorizeService.canView('agentDropdown') && appState?.companyInfoValue?.alias !== 'valuetest'"
          >
            <app-select-search-dropdown
              class="clients"
              label="Select Agents"
              [options]="multiSelectOptionsForAgents"
              [required]="false"
              [isHideSearch]="clearSearch"
              [lazyLoadComplete]="!hasMoreAgents"
              (selectedEvent)="updateSelectedOptions($event, 'agent')"
              (scrollEndEvent)="fetchNextAgentUserList()"
              (searchEvent)="searchAgentUser($event)"
              *ngIf="authorizeService.canView('agentDropdown') && appState?.companyInfoValue?.alias !== 'valuetest'"
            ></app-select-search-dropdown>
          </div>
          <div
            class="col-md-3 col-12"
            *ngIf="
              (authorizeService.canView('loanOfficerDropdown') && appState?.companyInfoValue?.alias !== 'valuetest') ||
              (appState?.companyInfoValue?.alias == 'valuetest' &&
                !this.userState.userDetails?.roles?.includes('companyManager'))
            "
          >
            <app-select-search-dropdown
              class="clients"
              label="Select Loan Officer"
              [options]="multiSelectOptionsForLoanOfficer"
              [required]="false"
              [isHideSearch]="clearSearch"
              [lazyLoadComplete]="!hasMoreLoanOfficers"
              (selectedEvent)="updateSelectedOptions($event, 'loanOfficer')"
              (scrollEndEvent)="fetchNextLoanOfficerUserList()"
              (searchEvent)="searchLoanOfficerUser($event)"
              *ngIf="authorizeService.canView('loanOfficerDropdown')"
            ></app-select-search-dropdown>
          </div>
        </div>

        <app-contacts
          [csvRecordColumnList]="csvRecordColumns"
          [filter]="filterApplied"
          (selectedRecordsEvent)="selectedRecords($event)"
          [editSelectedInfo]="editSelectedInfo"
          [campaignMode]="selectedCampaignInfo?.mode"
        >
        </app-contacts>

        <div class="row mt-4 mx-1 campaign-action">
          <div class="col-sm-6 col-12 text-left pl-4">
            <p *ngIf="!isLaunchAll">
              You have selected <strong>{{ campaignForm.controls?.contactIdList?.value?.length || 0 }}</strong> records!
            </p>
          </div>

          <p *ngIf="campaignError" style="color: red">{{ campaignError }}</p>
          <div class="col-sm-6 col-12 text-right">
            <mat-checkbox
              *ngIf="campaignMode != 'isAutomatedCampaign'"
              formControlName="launchCampaign"
              class="example-margin mt-1 mr-2"
              color="primary"
              (change)="launchNow()"
              [checked]="isLaunchNow"
            >
              Launch Now
            </mat-checkbox>
            <button mat-flat-button color="primary" type="button" (click)="createCampaign()">
              {{ this.campaignForm?.controls?.campaignId?.value ? 'Save' : 'Create Campaign' }}
            </button>
          </div>

          <!-- <div class="col-sm-6 col-12 text-right">
            <button mat-flat-button color="primary" type="button" (click)="createCampaign()">Add Contact</button>
          </div> -->
        </div>
      </form>
      <app-progress-indicator *ngIf="isLoading" text="Please wait while we load"></app-progress-indicator>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
